module.exports = __webpack_public_path__ + "static/narrations_creatives-39ebaa0731f91abf176f6daa32858359.mp4";